import actions from './mfa.actions'
import getters from './mfa.getters'
import mutations from './mfa.mutations'

// Initial state
const state = {
  qrCode: '',
}

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
}



// WEBPACK FOOTER //
// ./src/store/modules/mfa/index.js